import React, { Component } from 'react';
import { connect } from 'react-redux';
import { dAPI } from 'appSrc/api';
import LoadingReplace from 'appSrc/components/Shards/Loading/LoadingReplace';
import CategoriesTable from './Table';
import { DLModal } from 'appSrc/components/Shards';
import { PrimaryButton } from 'appSrc/components/UI';
import style from './styles/style.module.css';

class CategorySelectModal extends Component {
    constructor( props ) {
        super( props );

        this.state = {
            fetching: true,
            categories: [],
        };
        this.categoryQueryObject = {
            sort: 'id,child_categories.id',
        };
        this.checked = [];
        this.data = [];

        this.loadCategories();
    }
    loadCategories = () => {
        return this.props.getCategories( this.categoryQueryObject )
        .then( ( categories ) => {
            this.categoryQueryObject.page++;
            this.setState( ( altState ) => {
                altState.fetching = false;
                altState.categories = altState.categories.concat( categories );
                return altState;
            } );
            return categories;
        } );
    }
    tableChanged = ( { checked, data } ) => {
        this.checked = checked;
        this.data = data;
    }
    submit = () => {
        this.props.onSubmit( { checked: this.checked, data: this.data } );
    }

    render() {
        const { fetching, categories } = this.state;

        return (
            <DLModal title='Category Select'
            className={ style.categorySelectModal }
            closeHandler={ this.props.closeHandler }>
                <div className={ style.allList }>
                    { fetching ?
                        <LoadingReplace />
                        :
                        <CategoriesTable
                        categories={ categories }
                        initialValues={ this.props.initialValues }
                        onChange={ this.tableChanged }
                        singleSelect={ this.props.singleSelect }
                        defaultOpen={ this.props.defaultOpen }
                        hideOptions={ this.props.hideOptions }
                        elementHeight={ 70 } />
                    }
                </div>
                <div className={ style.buttons }>
                    <PrimaryButton label='Submit' onClick={ this.submit } />
                    <PrimaryButton label='Cancel' onClick={ this.props.closeHandler } />
                </div>
            </DLModal>
        );
    }
}
CategorySelectModal.defaultProps = {
    onSubmit: () => {},
};

const mapDispatchToProps = () => {
    return {
        getCategories: ( queryObject ) => {
            return dAPI.get( '/admin/categories/metrics', queryObject );
        },
    };
};

export default connect( null, mapDispatchToProps )( CategorySelectModal );
